module.exports = __webpack_public_path__ + "img/img (1).7f358ec5.jpg";